/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AppointmentPrint$Params {
  providerId?: string | null;
  isResource?: string | null;
  emrpracticeId?: string | null;
  apptDate?: string | null;
}

export function appointmentPrint(http: HttpClient, rootUrl: string, params?: AppointmentPrint$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, appointmentPrint.PATH, 'get');
  if (params) {
    rb.query('providerId', params.providerId, {});
    rb.query('isResource', params.isResource, {});
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('apptDate', params.apptDate, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

appointmentPrint.PATH = '/appointment/print';
